import PelckmansLogo from '@pelckmans/elementis/icons/pelckmans';
import Tabs from '@pelckmans/elementis/components/tabs';
import Page from '@pelckmans/elementis/components/page';
import Button from '@pelckmans/elementis/components/button';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { PropsWithChildren, useCallback } from 'react';
import ContentHeader from '../../layout/content/ContentHeader';
import ContentBody from '../../layout/content/ContentBody';
import ContentFooter from '../../layout/content/ContentFooter';
import Footer from '../../layout/footer/Footer';
import { buildGroupProps } from '../../utils/elementisUtils';
import { useRoutes } from '../../hooks/useRoutes';
import {
  withScrollThreshold,
  WithScrollThresholdProps,
} from '../../shared-components/elementis/hoc/withScrollThreshold';

export const TABS = {
  CONDITIONS: 'conditions',
  PRIVACY: 'privacy',
};

interface Props extends PropsWithChildren, WithScrollThresholdProps {}

function PolicyAndConditions({ pastThreshold, children }: Props) {
  const { t } = useTranslation();
  const { buildAbsolutePath } = useRoutes();

  const { getRoute } = useRoutes();
  const navigate = useNavigate();
  const location = useLocation();

  const selectedTab = location.pathname.includes(getRoute('TERMS_AND_CONDITIONS')) ? TABS.CONDITIONS : TABS.PRIVACY;

  const onTabChange = useCallback(
    (tab: string) => {
      if (tab === selectedTab) return;

      const route =
        tab === TABS.CONDITIONS ? buildAbsolutePath(['TERMS_AND_CONDITIONS']) : buildAbsolutePath(['PRIVACY_POLICY']);

      navigate(route);
    },
    [buildAbsolutePath, navigate, selectedTab],
  );

  return (
    <div className="page terms-and-conditions-page">
      <div className="page-content">
        <div className="main-layout">
          <div className="main-layout-container">
            <div className="content-layout">
              <main>
                <div className="margin-wrapper">
                  <Tabs selectedTab={selectedTab} onTabChange={onTabChange}>
                    <ContentHeader
                      cover={
                        <Page.Header
                          density={pastThreshold ? 'compact' : 'normal'}
                          headerText={t('PAGES.POLICY_AND_CONDITIONS.HEADER.TITLE')}
                          tabs={
                            <Tabs.TabList aria-label={t('PAGES.POLICY_AND_CONDITIONS.HEADER.TAB_LIST.A11Y_LABEL')}>
                              <Tabs.Tab id={TABS.CONDITIONS}>
                                {t('PAGES.POLICY_AND_CONDITIONS.HEADER.TAB_LIST.TABS.CONDITIONS')}
                              </Tabs.Tab>
                              <Tabs.Tab id={TABS.PRIVACY}>
                                {t('PAGES.POLICY_AND_CONDITIONS.HEADER.TAB_LIST.TABS.PRIVACY')}
                              </Tabs.Tab>
                            </Tabs.TabList>
                          }
                          buttonGroupProps={buildGroupProps(
                            <Button as="link" href="/" prominence="neutral" startIcon={<PelckmansLogo />}>
                              {t('PAGES.HELP.RETURN_TO_PLATFORM.LABEL')}
                            </Button>,
                          )}
                        />
                      }
                    />
                    <ContentBody>{children}</ContentBody>
                    <ContentFooter>
                      <Footer />
                    </ContentFooter>
                  </Tabs>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withScrollThreshold(PolicyAndConditions);
